import type { SqliteDataType } from './types';

/**
 * Maps API column types to SQLite data types
 * 
 * @param inputType - The input type from the API (e.g., "text", "number", "boolean")
 * @returns The corresponding SQLite data type
 */
export function mapToSqliteType(inputType: string | undefined): SqliteDataType {
  switch (inputType) {
    case "boolean":
    case "foreign_key":
      return "integer";
    case "number":
      return "real";
    case "date":
    case "datetime":
    case "json":
    case "array":
    case "varchar":
    case "text":
      return "text";
    case "real":
    case "numeric":
    case "blob":
    case "integer":
      return inputType as SqliteDataType;
    default:
      return "text";
  }
}
